type Props = {
  children: any;
};

export default function WithoutHeaderLayout(props: Props) {
  const { children } = props;

  return <>{children}</>;
}
